import {GetProvidersDetailsDentalGuide} from 'domain/usecases';
import {RemoteGetProvidersDetailsDentalGuide} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {GuideFlowEndpoints} from 'main/factories/usecases/endpoints';

export const makeGetProvidersDetailsDentalGuide = (): GetProvidersDetailsDentalGuide =>
	new RemoteGetProvidersDetailsDentalGuide(
		makeBFFApiUrl(GuideFlowEndpoints.odontoGuideProvidersDetails),
		makeAuthorizeHttpClientDecorator(),
	);
